export default __webpack_public_path__ + "static/media/about.2dee8a0f.png";